import type { Tenant } from '@owl-frontend/api-client/interface';
import { AsyncActionState, setupSlice } from '@owl-frontend/redux';

export interface TenantState {
  tenant?: Tenant;
  actions: {
    fetchTenant: AsyncActionState;
  };
}

const initialState: TenantState = {
  actions: {
    fetchTenant: { status: 'uninitialized' },
  },
};

const tenantSlice = setupSlice('tenant', initialState);
export default tenantSlice;
